import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import CardList from "@/components/CardList.vue";
let DragAndDrop = /** @class */ (() => {
    let DragAndDrop = class DragAndDrop extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Drag and Drop";
            this.items = [
                {
                    text: "Drag and Drop",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
        }
        mounted() {
            setTimeout(() => {
                this.pageIsLoading = false;
            }, 100);
        }
    };
    DragAndDrop = __decorate([
        Component({
            name: "DragAndDrop",
            components: {
                Layout,
                PageHeader,
                Loader,
                CardList
            }
        })
    ], DragAndDrop);
    return DragAndDrop;
})();
export default DragAndDrop;
